import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { FooterText } from '@/components/text/footer-text';
const FOOTER_LINKS = [{
  title: 'Estúdio',
  links: [{
    label: 'Clientes',
    href: '#clients'
  }, {
    label: 'Projetos',
    href: '#cases'
  }, {
    label: 'Processo',
    href: '#process'
  }]
}, {
  title: 'Serviços',
  links: [{
    label: 'Acabamentos',
    href: '#finishes'
  }, {
    label: 'Depoimentos',
    href: '#testimonials'
  }, {
    label: 'Perguntas Frequentes',
    href: '#faq'
  }]
}, {
  title: 'Recursos',
  links: [{
    label: 'Portfólio',
    href: '#cases'
  }, {
    label: 'Processo',
    href: '#process'
  }, {
    label: 'Contacto',
    href: '#contact'
  }]
}
// Contact column replaced with icon-based Connect section rendered separately below
];
const SOCIAL_LINKS = [{
  name: 'Facebook',
  href: 'https://www.facebook.com/share/17PKzwoZ3A/',
  icon: <svg aria-hidden="true" viewBox="0 0 24 24" className="size-[22px]">
        {/* Facebook logomark */}
        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3.5l.5-4H14V7a1 1 0 0 1 1-1h3Z" fill="currentColor" />
      </svg>
}, {
  name: 'Instagram',
  href: 'https://www.instagram.com/lapidsrevestments?igsh=ZzJsbGV2cDMxMDlu',
  icon: <svg aria-hidden="true" viewBox="0 0 24 24" className="size-[22px]">
        {/* Instagram outline */}
        <rect x="3" y="3" width="18" height="18" rx="5" ry="5" fill="none" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="12" cy="12" r="3.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="17.2" cy="6.8" r="1.2" fill="currentColor" />
      </svg>
}, {
  name: 'WhatsApp',
  href: 'https://wa.me/351938952790?text=Hello%20LAPIDS',
  icon: <svg aria-hidden="true" viewBox="0 0 24 24" className="size-[22px]">
        {/* WhatsApp-inspired chat bubble with phone */}
        <path d="M20.5 12a8.5 8.5 0 1 1-3.06-6.51" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.2 18.6 4 20l1.4-3.2" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.5 10.5c.6 1.4 1.9 2.7 3.3 3.3l1.1-1.1a.9.9 0 0 1 1.1-.2l1.6.7" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
}, {
  name: 'Email',
  href: 'mailto:iangelomc@gmail.com?subject=Project%20enquiry',
  icon: <svg aria-hidden="true" viewBox="0 0 24 24" className="size-[22px]">
        {/* Envelope */}
        <rect x="3" y="5" width="18" height="14" rx="2" fill="none" stroke="currentColor" strokeWidth="1.6" />
        <path d="M3.5 7.5 12 13l8.5-5.5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
}];
export function SiteFooter() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Date().getFullYear();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const year = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = FOOTER_LINKS.map(_temp);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className="mb-[0.6rem] text-[0.8rem] uppercase tracking-[0.1em] text-muted">Contactos</h2>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="col-span-12 sm:col-span-6 lg:col-span-3">{t2}<nav aria-label="Social"><ul className="m-0 flex list-none flex-wrap gap-2.5 p-0">{SOCIAL_LINKS.map(_temp2)}</ul></nav><p className="mt-3 max-w-[28ch] text-[0.9rem] leading-snug text-muted">Prefere WhatsApp ou e-mail? Normalmente respondemos dentro de um dia útil.</p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span>© {year} Microcement Studio</span>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <footer className="border-t border-[color:color-mix(in_srgb,var(--color-ink)_18%,transparent)] bg-white px-fluid-x py-[calc(var(--space-fluid-y)*0.9)]"><div className="mx-auto grid max-w-container-max grid-cols-12 gap-3">{t1}{t3}<div className="col-span-full mt-2 flex flex-col items-start justify-between gap-3 border-t border-[color:color-mix(in_srgb,var(--color-ink)_18%,transparent)] pt-4 text-[0.9rem] text-muted sm:flex-row sm:items-center">{t4}<span className="flex gap-2"><Link href="/privacy-policy" className="text-ink transition-colors hover:text-accent">Política de Privacidade</Link><span>·</span><Link href="/terms-of-service" className="text-ink transition-colors hover:text-accent">Termos</Link></span></div></div></footer>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function _temp2(s) {
  return <li key={s.name}><Link href={s.href} target={s.href.startsWith("http") ? "_blank" : undefined} rel={s.href.startsWith("http") ? "noopener noreferrer" : undefined} aria-label={s.name} className="group inline-flex items-center justify-center rounded-full border border-line bg-white/70 px-3 py-2 text-ink/80 shadow-sm backdrop-blur-sm transition-transform duration-300 hover:-translate-y-[2px] hover:border-accent hover:bg-accent/10 hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50">{s.icon}<span className="sr-only">{s.name}</span></Link></li>;
}
function _temp(column) {
  return <FooterText key={column.title} title={column.title} links={column.links} className="col-span-12 sm:col-span-6 lg:col-span-3" />;
}